import * as angular from 'angular';

export class GridPagingController implements angular.IController {
    public static $controllerAs: string = 'gridPagingCtrl';

    public static $inject = [
        '$scope'
    ];

    private isPagingEnabled: boolean;
    private total: number;
    private limit: number;
    private onPaginate: (page: number, limit: number) => void;
    private page: number;
    private pageSelect: boolean;
    private pagingOptions: number[];

    constructor(
        private $scope: any
    ) {
    }

    public $onInit() {
        this.$scope.$watch('gridPagingCtrl.page', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.page = newValue;
                this.onPaginationChange();
            }
        });

        this.$scope.$watch('gridPagingCtrl.limit', (newValue, oldValue) => {
            if (newValue === oldValue) {
                return;
            }

            this.page = 0;
            this.onPaginationChange();
        });

        this.$scope.$watch('gridPagingCtrl.total', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.page = 0;
            }
            this.isPagingEnabled = this.limit && angular.isNumber(this.limit) && this.pages() > 1;
        });

        // tslint:disable-next-line: no-magic-numbers
        this.pagingOptions = this.pagingOptions || [5, 10, 15];
    }

    public first() {
        this.page = 0;
    }

    public hasNext() {
        return this.page < this.pages() - 1;
    }

    public hasPrevious() {
        return this.page > 0;
    }

    public last() {
        this.page = this.pages() - 1;
    }

    public next() {
        this.page++;
    }

    public onPaginationChange() {
        if (angular.isFunction(this.onPaginate)) {
            this.onPaginate(this.page, this.limit);
        }
    }

    public pages() {
        return Math.ceil(this.total / this.limit);
    }

    public previous() {
        this.page--;
    }

    public range() {
        return new Array(this.pages());
    }

    public showPageSelect() {
        let limit = 50;
        return this.pageSelect && this.pages() <= limit;
    }
}
